module.exports = __webpack_public_path__ + "static/media/2.2c0de3c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/九宫格未选中态/2.png
// module id = 942
// module chunks = 0